export default __webpack_public_path__ + "static/media/mms-badge-latest.8924438d.svg";